import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const processed = useRef(false);
  const nav = useNavigate();
  const location = useLocation();
  const { handleAuth } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const next = sessionStorage.getItem("homiin_next") || "/dashboard";
    const save = sessionStorage.getItem("homiin_save");
    sessionStorage.removeItem("homiin_next");
    sessionStorage.removeItem("homiin_save");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        handleAuth(data);
        if (save && next.startsWith("/quote/")) await api.post(`/quotes/${next.split("/")[2]}/save`).catch(() => {});
        window.history.replaceState(null, "", location.pathname);
        nav(next, { replace: true, state: { user: data.user } });
      } catch (e) {
        toast.error(formatErr(e));
        window.history.replaceState(null, "", "/login");
        nav("/login", { replace: true });
      }
    })();
  }, [location, nav, handleAuth]);

  return (
    <div className="min-h-[60vh] grid place-items-center" data-testid="auth-callback">
      <div className="text-center"><Loader2 className="w-6 h-6 animate-spin text-brand-accent mx-auto" /><p className="text-sm text-brand-muted mt-3">Signing you in…</p></div>
    </div>
  );
}
